import { render, staticRenderFns } from "./DashboardSchool.vue?vue&type=template&id=7f14c2f3&"
import script from "./DashboardSchool.vue?vue&type=script&lang=js&"
export * from "./DashboardSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports